import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { compose, branch, lifecycle, renderComponent } from 'recompose';

import authHOC from '../Components/AuthHOC';
import Spinner from '../Components/Spinner';
import ToolsView from './Components/ToolsView';

import {
  getClientBackGroundRequest,
  toggleSaveEditPopup,
  toggleUserDashboard,
  toggleRefererPage,
} from '../redux/reducers/view';
import { authAdminRequest, authUserRequest, getTokenFromCookies } from '../redux/reducers/login';
import {
  getUserProgramsFullRequest,
  selectUserPrograms,
  selectUserModule,
} from '../redux/reducers/userProgramsFull';
import { connectedUsersRequest } from '../redux/reducers/connectedUsers';
import SessionsView from './Components/SessionsView';
import { webinarListRequest } from '../redux/reducers/contentList';
import { dropdownsRequest } from '../redux/reducers/dropdowns';

const Sessions = ({ view }) => <SessionsView view={view} />;

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  view: state.viewReducer,
  savedVersions: state.savedVersionsReducer,
  userProgramsFull: state.userProgramsFullReducer,
  contentList: state.contentListReducer
});

const mapDispatchToProps = dispatch => ({
  getToken: token => dispatch(getTokenFromCookies(token)),
  authUser: () => dispatch(authUserRequest()),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  getClientBackGroundRequest: () => dispatch(getClientBackGroundRequest()),
  toggleSaveEditPopup: value => dispatch(toggleSaveEditPopup(value)),
  getUserProgramsFullRequest: () => dispatch(getUserProgramsFullRequest()),
  connectedUserRequest: () => dispatch(connectedUsersRequest()),
  toggleUserDashboard: value => dispatch(toggleUserDashboard(value)),
  selectUserPrograms: programId => dispatch(selectUserPrograms(programId)),
  selectUserModule: moduleId => dispatch(selectUserModule(moduleId)),
  toggleRefererPage: moduleId => dispatch(toggleRefererPage(moduleId)),
  getSessionsList: () => dispatch(webinarListRequest()),
  dropdownsRequest: () => dispatch(dropdownsRequest()),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  authHOC,
  lifecycle({
    componentWillMount() {
      const {
        loginReducer,
        getClientBackGroundRequest,
        view,
        savedVersions,
        toggleSaveEditPopup,
        userProgramsFull,
        getUserProgramsFullRequest,
        toggleUserDashboard,
        toggleRefererPage,
        getSessionsList,
        contentList
      } = this.props;
      const isLoggedIn = loginReducer.user && loginReducer.user.userId;

     
      if (isLoggedIn && contentList.isFetched === false) {
        getSessionsList();
      }
      if (savedVersions.pathToSaveVersion !== null) {
        //toggleSaveEditPopup(true);
      }
      toggleUserDashboard(false);
    },
    componentWillReceiveProps(nextProps) {
      const {
        loginReducer,
        getClientBackGroundRequest,
        view,
        userProgramsFull,
        getUserProgramsFullRequest,
        selectUserPrograms,
        contentList,
        getSessionsList
        // selectUserModule,
      } = nextProps;
      const isLoggedIn = loginReducer.user && loginReducer.user.userId;
     
      if (
        isLoggedIn &&
        contentList.isFetched === false &&
        contentList.fetching === false
      ) {
        getSessionsList();
      }

      if (userProgramsFull.selectedProgramId === null && nextProps.match.path=='/sessions/:programId') {
        
        selectUserPrograms(parseInt(nextProps.match.params.programId));
        // selectUserModule(userProgramsFull.programs.programs[0].modules[0].moduleId);
      }
     
    },
  }),
 
)(Sessions);

Sessions.propTypes = {
  view: PropTypes.instanceOf(Object),
};
